export const Links = {
	PRIVACY_POLICY: 'https://www.scoro.com/privacy-policy/',
	TERMS_OF_USE: 'https://www.scoro.com/terms-of-use/',
};
